/**
 * SMS segment counting for display and cost estimation.
 * Matches backend: GSM-7 160/153 chars per segment, UCS-2 70/67 per segment.
 * Must match backend SMS_NO_REPLY_SUFFIX for accurate cost estimates.
 */
export const SMS_NO_REPLY_SUFFIX = ' No reply to this number.';
const GSM7_SINGLE = 160;
const GSM7_MULTI = 153;
const UCS2_SINGLE = 70;
const UCS2_MULTI = 67;

function isGsm7(text: string): boolean {
  for (let i = 0; i < text.length; i++) {
    if (text.charCodeAt(i) > 127) return false;
  }
  return true;
}

/** Returns the number of SMS segments for the given message body. */
export function getSmsSegmentCount(body: string): number {
  const len = (body || '').length;
  if (len === 0) return 0;
  if (isGsm7(body)) {
    if (len <= GSM7_SINGLE) return 1;
    return Math.ceil(len / GSM7_MULTI);
  }
  if (len <= UCS2_SINGLE) return 1;
  return Math.ceil(len / UCS2_MULTI);
}
